// Registre des plugins côté frontend.
//
// Chaque plugin est un dossier de `src/plugins/<clé>/` dont l'index exporte
// un MANIFESTE léger (clé, nom, chargeur du module vitrine, écrans admin).
// Le code réel du plugin (capture d'événements, tableau de bord…) est chargé
// à la demande (`import()` dynamique) : il ne pèse rien dans le bundle
// initial de la vitrine et son échec de chargement n'affecte pas la boutique.
//
// Installer un plugin = ajouter son manifeste à PLUGINS ci-dessous (et le
// dossier correspondant côté backend, `backend/plugins/<clé>/`). C'est le
// SEUL endroit du cœur qui connaît la liste des plugins ; le reste (App.js,
// AdminLayout.jsx) passe par les helpers ci-dessous.
//
// L'activation, elle, se décide par boutique dans le back-office (Plateforme
// › Plugins) : un manifeste présent ici mais inactif pour la boutique n'est
// jamais monté (voir PluginHost.jsx et GET /api/plugins).

import eventTracking from "@/plugins/event-tracking";

export const PLUGINS = Object.freeze({
  [eventTracking.key]: eventTracking,
});

export function getPluginManifest(key) {
  return PLUGINS[key] || null;
}

// Routes admin déclarées par les plugins, à monter sous /admin (App.js).
export function pluginAdminRoutes() {
  return Object.values(PLUGINS).flatMap((m) =>
    (m.admin?.routes || []).map((r) => ({ ...r, pluginKey: m.key })),
  );
}

// Sous-entrées de navigation qu'un plugin accroche à un lien parent existant
// (ex. parent "/admin/regie" → « Événements & parcours »), voir AdminLayout.
export function pluginNavChildren(parentTo) {
  return Object.values(PLUGINS).flatMap((m) =>
    (m.admin?.nav || [])
      .filter((n) => n.parent === parentTo)
      .map(({ to, label, end }) => ({ to, label, end, pluginKey: m.key })),
  );
}
